// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Sv43","label":"styles_label__2JWvy"};